import React, { useEffect, useState } from "react";
import { Panel } from "components/panel";
import PropTypes from "prop-types";
import "./Panel.css";
import { ShowHide } from 'components/layout';
import classNames from 'classnames';
import { Collapse, Icon } from "@blueprintjs/core";

export function ActionPanel({
    intent,
    title,
    children,
    colour,
    loadingData,
    collapsable = false,
    expanded = true,
    onClick = () => { }
}) {
    const [panelColour, setPanelColour] = useState("");

    useEffect(() => {
        if (colour) {
            setPanelColour(colour);
        } else if (intent) {
            switch (intent.toLowerCase()) {
                case "warning":
                    setPanelColour("#FF9076")
                    break;
                case "info":
                case "primary":
                    setPanelColour("#008CFF");
                    break;
                case "danger":
                    setPanelColour("#F0578A");
                    break;
                case "success":
                    setPanelColour("#00C6B2");
                    break;
                default:
                    setPanelColour("#737373");
                    break;
            }
        }

    }, [intent, colour]);

    return (
        <>
            <Panel color={panelColour} disabled={loadingData} className={classNames("action-panel-box", { "bp6-skeleton": loadingData, "action-panel-expandable": collapsable, "action-panel-collapsed": !expanded })}>
                <div className="action-panel-title" onClick={onClick} onKeyDown={() => { }} role="switch" tabIndex={0} aria-checked={expanded}>
                    <h3>{title}</h3>
                    <ShowHide
                        evaluator={collapsable}
                        show={
                            <Icon className="collapsable-icon-status" icon={expanded ? "chevron-up" : "chevron-down"} />
                        }
                    />
                </div>
                <Collapse isOpen={expanded}>
                    <div className="action-panel-content">{children}</div>
                </Collapse>
            </Panel>
        </>
    );
}

ActionPanel.propTypes = {
    intent: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    colour: PropTypes.string,
    loadingData: PropTypes.bool,
    collapsable: PropTypes.bool,
    expanded: PropTypes.bool,
    onClick: PropTypes.func,
};
